import React, { useState } from 'react';
import { Button, Typography, Space, Image } from 'antd';
import { MailOutlined, GoogleOutlined, CloseOutlined } from '@ant-design/icons';
import './NewEmailSetup.css';
import emailIcon from "../../Assets/EmailCapture/email-icon.png";
import LearnMoreModal from '../../Components/LearnMore/LearnMoreModal';
const { Title, Text, Paragraph  } = Typography;

const StepOne = ({ onNext, onSkip }) => {
  const [learnMoreVisible, setLearnMoreVisible] = useState(false);
  return (
  <div>
    {/* Title and Close Button */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Title className='emailSetupTitle' level={2} style={{ margin: 0 }}>Email Assistant</Title>
      <Button
        type="text"
        icon={<CloseOutlined />}
        onClick={onSkip}
        style={{color:"#bbb", opacity:"1"}}
      />
    </div>
    <div className='emailSetupStep1Cont'>
<Title className='emailSetupTitleBtm' level={3}>Stay Organised with Quelld’s Email Assistant</Title>
    <Paragraph  className='emailSetupTxtBtm'>
    Automatically extract school emails, create events, and send reminders—so you never miss an important update.
    </Paragraph >

    <div style={{ fontSize: 48, margin: '20px 0', textAlign: 'center' }}>
    <Image
  src={emailIcon}
  preview={false}
  alt="Email setup illustration"
/>
    </div>

    <Space direction="vertical" style={{ width: '100%' }}>
      <Button className='setup-btn' type="primary" block onClick={onNext}>
      Set Up Now
      </Button>
      <LearnMoreModal moduleName="email_assistant" buttonType="default" buttonClass="modal-btn" />
    </Space>
    </div>

    
  </div>)
};

export default StepOne;
